import { Button, Typography } from '@material-ui/core';
import { Training as CoreTraining } from 'shared/medyx-core/types/training';
import React, { useEffect, useState } from 'react';
import request, { downloadFile } from 'app/infrastructure/api/apiUtils';
import RALPH_API_BASE_URL from 'app/infrastructure/api/ralphApi';
import { ActivityStatus } from 'shared/medyx-core/types/activity';
import FormElement from 'app/components/Form/FormElement/FormElement';
import { SwitchField } from 'app/components/Form/Fields';
import { useSelector } from 'react-redux';
import { selectIsFormDirty } from 'app/training/adapters/store/selectors';

interface Props {
  trainingPeriod: CoreTraining;
}

const PdfSection = ({ trainingPeriod }: Props) => {
  const isFormDirty = useSelector(selectIsFormDirty());

  const handlePdfButtonClick = (firebaseId: string | undefined) => {
    if (!firebaseId) {
      return;
    }

    if (trainingPeriod.status === ActivityStatus.NO_STATUS) {
      return;
    }

    const PAYMENT_REQUEST_FORM_URL = `${RALPH_API_BASE_URL}/activities/${firebaseId}/pdf-form`;

    request(PAYMENT_REQUEST_FORM_URL, { method: 'GET' }).then((response) => {
      downloadFile(response);
    });
  };

  return (
    <div className="flex gap-4 sm:flex-row sm:items-start">
      <Button className={'justify-center'} variant="contained" onClick={() => handlePdfButtonClick(trainingPeriod.id)}>
        Générer PDF
      </Button>

      <div className="flex-col">
        <FormElement
          label="Inclure les allocations forfaitaires"
          name="hasFlatRateAllowances"
          component={SwitchField}
        />

        {isFormDirty ? (
          <Typography variant="body2" color="error">
            Sauvegardez le formulaire avant de générer le PDF
          </Typography>
        ) : null}
      </div>
    </div>
  );
};

export default PdfSection;
